import Cognito from './cognito';

export interface AuthorizationHeaders {
  headers: {
    'Content-Type': string;
    Accept: string;
    Authorization?: string;
  };
}

export default class AuthorizationHeader {
  static async getCognitoHeader(version = '3.1.0'): Promise<AuthorizationHeaders> {
    const session = await Cognito.fetchCognitoCredentials();
    const authorizationHeader: AuthorizationHeaders = {
      headers: {
        'Content-Type': 'application/json',
        Accept: `application/json; version=${version}`,
      },
    };
    if (session) {
      authorizationHeader.headers.Authorization = `Bearer ${session.token}`;
    }
    return authorizationHeader;
  }
}
